<div id="main" class="min-w-screen min-h-screen flex items-center justify-center px-5 py-5" style="background:#3D3D3D;">
    <div class="bg-gray-100 text-gray-500 rounded-3xl shadow-xl w-full overflow-hidden" style="max-width:1000px;padding-bottom:50px;">
        <div class="mainbox lg:flex h-full w-full">
            <div class="hidden lg:block w-1/5 py-3 px-3" style="background:#CB5727;display:flex;justify-content: center;align-items: center;">
              <img src="assets/logo5.png">
            </div>
            <div class="w-full lg:w-2/3 py-3 px-5 lg:px-10 relative">
                <div class="text-center mb-10">
                    <h1 class="font-bold text-3xl text-gray-700">REGISTER</h1>
                    <p>Please fill out the following information and sign the terms and conditions <br>
                        on the last page. Once the form is submitted, your details will be sent through to us.
                    </p>                
                </div>

                <div >
                    <div class="flex dot-box mb-3">
                        <!--DOT1-->
                        <div class="dotGroup relative">
                        <div class="line "></div>                        
                        <div class="dot" (click)="page=0" [ngClass]="{'active': page>=0 }"></div>
                        </div>

                        <!--DOT2-->
                        <div class="dotGroup relative">
                        <div class="line " [ngClass]="{'active': page>=1 }"></div>                        
                        <div class="line-gray " [ngClass]="{'active': page>=1 }"></div>
                        <div class="dot" (click)="goToPage(1)" [ngClass]="{'active': page>=1 }"></div>
                        </div>
                        
                        <!--DOT3-->
                        <div class="dotGroup relative">
                        <div class="line " [ngClass]="{'active': page>=2 }"></div>     
                        <div class="line-gray " [ngClass]="{'active': page>=2 }"></div>
                        <div class="dot" (click)="goToPage(2)" [ngClass]="{'active': page>=2 }"></div>
                        </div>

                        <!--DOT4-->
                        <div class="dotGroup relative">
                        <div class="line line4" [ngClass]="{'active': page>=3 }"></div>
                        <div class="line-gray line4" [ngClass]="{'active': page>=3 }"></div>              
                        <div class="dot" (click)="goToPage(3)" [ngClass]="{'active': page>=3 }"></div>
                        </div>

                        <!--DOT5-->
                        <div class="dotGroup relative">
                        <div class="line line5" [ngClass]="{'active': page>=4 }"></div>
                        <div class="line-gray line5" [ngClass]="{'active': page>=4 }"></div>                   
                        <div class="dot" (click)="goToPage(4)" [ngClass]="{'active': page>=4 }"></div>
                        </div>

                        <!--DOT6-->
                        <div class="dotGroup relative">
                        <div class="line line6" [ngClass]="{'active': page>=5 }"></div>
                        <div class="line-gray line6" [ngClass]="{'active': page>=5 }"></div>                   
                        
                        </div>

                        
                    </div>              
                    
                    
                    <div [ngStyle]="{'opacity':loading ? '0.5':1}"> 

                        <!----PAGE ONE---->
                        <ng-container *ngIf="page==0">


                        <form [formGroup]="basicInfoForm">
                        <h1><strong class="text-yellow-700">Step1: </strong> </h1>
                    <h1>Name Information</h1>
                    <div class="flex -mx-3">
                        <div class="w-1/2 px-3 mb-5">
                            <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>Title </label>
                            <div class="flex">
                                <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-account-outline text-gray-400 text-lg"></i></div>
                                <select [ngClass]="{'invalid':basicInfoForm.controls.title.invalid && basicInfoForm.controls.title.touched,
                                                    'valid':!basicInfoForm.controls.title.invalid && basicInfoForm.controls.title.touched}" style="padding-left:35px;margin-left:-35px;width:250px;height:39px;border:black solid 1px;border-radius:10px;background:white;" formControlName="title">
                                    <option [value]="'Mr.'">Mr.</option>
                                    <option [value]="'Mrs.'">Mrs.</option>                        
                                    <option [value]="'Ms.'">Ms.</option>                        
                                    <option [value]="'Miss.'">Miss.</option>
                                    <option [value]="'Mx.'">Mx.</option>
                                    <option [value]="'Prof.'">Prof.</option>
                                    <option [value]="'Dr.'">Dr.</option>
                                    <option [value]="'Master.'">Master.</option>
                                </select><br>
                            </div>
                        </div>                       
                        <div class="w-1/2 px-3 mb-5">
                            <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>First name</label>
                            <div class="flex">
                                <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-account-outline text-gray-400 text-lg"></i></div>
                                <input [ngClass]="{'invalid':basicInfoForm.controls.firstName.invalid && basicInfoForm.controls.firstName.touched,
                                                    'valid':!basicInfoForm.controls.firstName.invalid && basicInfoForm.controls.firstName.touched}" type="text" formControlName="firstName" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                            </div>
                        </div>                       
                    </div>
                    <div class="flex -mx-3">
                        <div class="w-1/2 px-3 mb-5">
                          <label for="" class="text-md font-semibold px-1">Middle name</label>
                          <div class="flex">
                              <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-account-outline text-gray-400 text-lg"></i></div>
                              <input type="text" formControlName="middleName" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                          </div>
                      </div>    
                        <div class="w-1/2 px-3 mb-5">
                            <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>Last name</label>
                            <div class="flex">
                                <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-account-outline text-gray-400 text-lg"></i></div>
                                <input [ngClass]="{'invalid':basicInfoForm.controls.lastName.invalid && basicInfoForm.controls.lastName.touched,
                                                    'valid':!basicInfoForm.controls.lastName.invalid && basicInfoForm.controls.lastName.touched}" type="text" formControlName="lastName" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                            </div>
                        </div>
                    </div>
                    <h1>Contact Information & Birthday</h1>
                    <div class="flex -mx-3 flex-wrap">
                        <div style="min-width: 300px" class="w-full px-3 mb-5">
                            <label for="" class="text-xs font-semibold px-1"><strong style="color:red;">*</strong>Email</label>
                            <div class="flex">
                                <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-email-outline text-gray-400 text-lg"></i></div>
                                <input [ngClass]="{'invalid':basicInfoForm.controls.email.invalid && basicInfoForm.controls.email.touched,
                                                   'valid':!basicInfoForm.controls.email.invalid && basicInfoForm.controls.email.touched}" type="email" formControlName="email" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                            </div>                            
                        </div>                        
                        <div class="w-full px-3 mb-5">
                            <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>Birthday</label>
                            <div class="flex">
                                    <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-account-outline text-gray-400 text-lg"></i></div>
                                    <select formControlName="b_month" style="padding-left:15px;margin-left:-35px;width:70px;height:39px;border:black solid 1px;border-radius:10px;background:white;" 
                                    [ngClass]="{'invalid':basicInfoForm.controls.b_month.invalid && basicInfoForm.controls.b_month.touched,
                                            'valid':!basicInfoForm.controls.b_month.invalid && basicInfoForm.controls.b_month.touched}"
                                    >
                                            <option [value]="'1'">Jan</option>
                                            <option [value]="'2'">Feb</option>                        
                                            <option [value]="'3'">Mar</option>
                                            <option [value]="'4'">Apr</option>
                                            <option [value]="'5'">May</option>
                                            <option [value]="'6'">Jun</option>
                                            <option [value]="'7'">Jul</option>
                                            <option [value]="'8'">Aug</option>
                                            <option [value]="'9'">Sep</option>                        
                                            <option [value]="'10'">Oct</option>
                                            <option [value]="'11'">Nov</option>
                                            <option [value]="'12'">Dec</option>
                                        </select>
                                        <select formControlName="b_day" style="padding-left:15px;margin-left:5px;width:70px;height:39px;border:black solid 1px;border-radius:10px;background:white;" 
                                        [ngClass]="{'invalid':basicInfoForm.controls.b_day.invalid && basicInfoForm.controls.b_day.touched,
                                            'valid':!basicInfoForm.controls.b_day.invalid && basicInfoForm.controls.b_day.touched}"
                                        >
                                                <option *ngFor="let i of daysArray;index as idx;" 
                                                [value]="idx+1">{{idx+1}}</option>
                                        </select>
                                        <select formControlName="b_year" style="padding-left:15px;margin-left:5px;width:100px;height:39px;border:black solid 1px;border-radius:10px;background:white;"  
                                        [ngClass]="{'invalid':basicInfoForm.controls.b_year.invalid && basicInfoForm.controls.b_year.touched,
                                            'valid':!basicInfoForm.controls.b_year.invalid && basicInfoForm.controls.b_year.touched}"
                                        >
                                                <option *ngFor="let i of yearArray;index as idx;" 
                                                [value]="(today.getUTCFullYear()-idx).toString()">{{(today.getUTCFullYear()-idx).toString()}}</option>
                                        </select>
                                        <div *ngIf="minorAlert" class="birthday-youth-warn">
                                            *Alert: If you are under 16 you need an adult to sign your safety waiver 
                                        </div>                
                                </div>                                
                        </div>                                
                    </div>                    
                    <div class="flex -mx-3">
                        <div class="w-full px-3 mb-5">
                            <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>Phone</label>
                            <div class="flex">
                                <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-email-outline text-gray-400 text-lg"></i></div>
                                <input [ngClass]="{'invalid':basicInfoForm.controls.phone.invalid && basicInfoForm.controls.phone.touched,
                                                    'valid':!basicInfoForm.controls.phone.invalid && basicInfoForm.controls.phone.touched}" type="tel" formControlName="phone" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                            </div>
                        </div>

                        <!----
                        <div class="w-full px-3 mb-5">
                            <label for="" class="text-md font-semibold px-1">Work Phone</label>
                            <div class="flex">
                                <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-email-outline text-gray-400 text-lg"></i></div>
                                <input  type="tel" formControlName="workPhone" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                            </div>
                            </div>
                        -->
                    </div>
                </form>
                </ng-container>

                <!----PAGE 2 ---->
                <ng-container *ngIf="page==1">
                    <form [formGroup]="addressInfoForm">                    
                    <h1><strong class="text-yellow-700">Step2: </strong></h1>

                    <!--<h1>Address Information</h1>
                    <div class="flex -mx-3">
                      <div class="w-full px-3 mb-5">
                          <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>Street 1</label>
                          <div class="flex">
                              <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-lock-outline text-gray-400 text-lg"></i></div>
                              <input [ngClass]="{'invalid':addressInfoForm.controls.street.invalid && addressInfoForm.controls.street.touched,
                                                'valid':!addressInfoForm.controls.street.invalid && addressInfoForm.controls.street.touched}"type="text" formControlName="street" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                          </div>
                      </div>
                      <div class="w-full px-3 mb-5">
                        <label for="" class="text-md font-semibold px-1">Street 2</label>
                        <div class="flex">
                            <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-lock-outline text-gray-400 text-lg"></i></div>
                            <input type="text" formControlName="street2" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                        </div>
                      </div>
                  </div>
                  <div class="flex -mx-3">
                    <div class="w-full px-3 mb-5">
                      <label for="" class="text-md font-semibold px-1">
                        <strong style="color:red;">*</strong>City
                      </label>
                      <div class="flex">
                          <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-lock-outline text-gray-400 text-lg"></i></div>
                          <input type="text" [ngClass]="{'invalid':addressInfoForm.controls.city.invalid && addressInfoForm.controls.city.touched,
                                                        'valid':!addressInfoForm.controls.city.invalid && addressInfoForm.controls.city.touched}" formControlName="city" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                      </div>
                    </div>
                    <div class="w-full px-3 mb-5">
                            <label for="" class="text-md font-semibold px-1">
                                State / Province
                            </label>
                            <div class="flex">
                                <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-lock-outline text-gray-400 text-lg"></i></div>
                                <input type="text" [ngClass]="{'invalid':addressInfoForm.controls.state.invalid && addressInfoForm.controls.state.touched,
                                                            'valid':!addressInfoForm.controls.state.invalid && addressInfoForm.controls.state.touched}" formControlName="state" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                            </div>
                          </div>
                --------END-----------
                </div>
                ------END-BLOCK--------
                <div class="flex -mx-3">
                    <div class="w-full px-3 mb-5">
                      <label for="" class="text-md font-semibold px-1">
                        <strong style="color:red;">*</strong>Country
                      </label>
                      <div class="flex">
                          <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-lock-outline text-gray-400 text-lg"></i></div>
                          <input type="text" [ngClass]="{'invalid':addressInfoForm.controls.country.invalid && addressInfoForm.controls.country.touched,
                                                         'valid':!addressInfoForm.controls.country.invalid && addressInfoForm.controls.country.touched}" formControlName="country" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                      </div>
                    </div>
                    <div class="w-full px-3 mb-5">
                      <label for="" class="text-md font-semibold px-1">
                        Postcode
                      </label>
                      <div class="flex">
                          <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-lock-outline text-gray-400 text-lg"></i></div>
                          <input type="text" [ngClass]="{'invalid':addressInfoForm.controls.postCode.invalid && addressInfoForm.controls.postCode.touched,
                                                        'valid':!addressInfoForm.controls.postCode.invalid && addressInfoForm.controls.postCode.touched}" formControlName="postCode" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                      </div>
                    </div>
                </div>-->
                <h1>Emergency Contact Information</h1>
                <!-------EMERGENCY CONTACT------->
                <div class="flex -mx-3">
                  <div class="w-full px-3 mb-5">
                      <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>Contact Name</label>
                      <div class="flex">
                          <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-lock-outline text-gray-400 text-lg"></i></div>
                          <input type="text" [ngClass]="{'invalid':addressInfoForm.controls.emergencyContactName.invalid && addressInfoForm.controls.emergencyContactName.touched,
                                                        'valid':!addressInfoForm.controls.emergencyContactName.invalid && addressInfoForm.controls.emergencyContactName.touched}"  formControlName="emergencyContactName" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                      </div>
                  </div>
                  <div class="w-full px-3 mb-5">
                    <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>Contact Relationship</label>
                    <div class="flex">
                        <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-lock-outline text-gray-400 text-lg"></i></div>
                        <input type="text" [ngClass]="{'invalid':addressInfoForm.controls.emergencyContactRelation.invalid && addressInfoForm.controls.emergencyContactRelation.touched,
                                                        'valid':!addressInfoForm.controls.emergencyContactRelation.invalid && addressInfoForm.controls.emergencyContactRelation.touched}"  formControlName="emergencyContactRelation" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                    </div>
                </div>
                </div>
                <!----EMERGENCY CONTACT PHONE-->
                <div class="flex -mx-3">
                <div class="w-full px-3 mb-5">
                      <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>Contact Phone</label>
                      <div class="flex">
                          <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-lock-outline text-gray-400 text-lg"></i></div>
                          <input type="tel" [ngClass]="{'invalid':addressInfoForm.controls.emergencyContactPhone.invalid && addressInfoForm.controls.emergencyContactPhone.touched,
                                                        'valid':!addressInfoForm.controls.emergencyContactPhone.invalid && addressInfoForm.controls.emergencyContactPhone.touched}"  formControlName="emergencyContactPhone" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none " >
                      </div>
                  </div>
              </div>
            </form>
        </ng-container>
            <ng-container *ngIf="page==2">
              <h1>Children(Signing as parent)</h1>
            <div *ngIf="addingChild; else notAdding" style="display:inline-block;margin-right:5px;"> 
                    <ng-container *ngIf="!editingChild;else normalAdd;">
                    Adding Another Child...
                    </ng-container>
                    <ng-template #normalAdd>
                    {{ childSelection ? "Editing Child Details for " + childSelection.firstName + " " + childSelection.lastName : ''}}
                    </ng-template>
            </div>
            <ng-template #notAdding>
                    <button style="background:purple;" (click)="resetChildForm();addingChild=true" class="button button-next mr-1 text-white px-2 py-1 font-semibold hover-purple">+ Add Another Child</button>     
                </ng-template>

                <ng-container *ngIf="childrens.length==0;else showChildren">
                <div *ngIf="!addingChild" class="added_child_list">
                    <option >No Children Added</option>
                </div>
            </ng-container>
            
            <ng-template #showChildren>
                    <div class="added_child_list">
                            <button  class="button button-next mr-1 px-2 py-1 font-semibold text-white" style="border-radius:5px;padding-left:5px;padding-right:5px;display:flex;" *ngFor="let child of childrens" (click)="editChild(child)" >
                            {{child.firstName + " " + child.lastName}} &nbsp;
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                            </button>
                    </div>
            </ng-template>
              <div *ngIf="addingChild">

                <form [formGroup]="ChildForm">
                <div class="flex -mx-3">
                        <div class="w-1/2 px-3 mb-5">
                          <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>Title</label>
                          <div class="flex">
                              <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-account-outline text-gray-400 text-lg"></i></div>
                              <select  formControlName="title" style="padding-left:35px;margin-left:-35px;width:250px;height:39px;border:black solid 1px;border-radius:10px;background:white;"                               
                              [ngClass]="{'invalid':ChildForm.controls.title.invalid && ChildForm.controls.title.touched,
                                        'valid':!ChildForm.controls.title.invalid && ChildForm.controls.title.touched}"
                              >
                                <option [value]="'Mr.'">Mr.</option>
                                <option [value]="'Mrs.'">Mrs.</option>                        
                                <option [value]="'Ms.'">Ms.</option>
                                <option [value]="'Miss.'">Miss.</option>
                                <option [value]="'Mx.'">Mx.</option>
                                <option [value]="'Prof.'">Prof.</option>
                                <option [value]="'Dr.'">Dr.</option>
                                <option [value]="'Master.'">Master.</option>
                            </select><br>
                          </div>
                      </div>    
                        <div class="w-1/2 px-3 mb-5">
                            <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>Birthday</label>
                            <div class="flex">
                                <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-account-outline text-gray-400 text-lg"></i></div>
                                <select formControlName="b_month" style="padding-left:15px;margin-left:-35px;width:70px;height:39px;border:black solid 1px;border-radius:10px;background:white;" 
                                [ngClass]="{'invalid':ChildForm.controls.b_month.invalid && ChildForm.controls.b_month.touched,
                                        'valid':!ChildForm.controls.b_month.invalid && ChildForm.controls.b_month.touched}"
                                >
                                        <option [value]="'1'">Jan</option>
                                        <option [value]="'2'">Feb</option>                        
                                        <option [value]="'3'">Mar</option>
                                        <option [value]="'4'">Apr</option>
                                        <option [value]="'5'">May</option>
                                        <option [value]="'6'">Jun</option>
                                        <option [value]="'7'">Jul</option>
                                        <option [value]="'8'">Aug</option>
                                        <option [value]="'9'">Sep</option>                        
                                        <option [value]="'10'">Oct</option>
                                        <option [value]="'11'">Nov</option>
                                        <option [value]="'12'">Dec</option>
                                    </select>
                                    <select formControlName="b_day" style="padding-left:15px;margin-left:5px;width:70px;height:39px;border:black solid 1px;border-radius:10px;background:white;" 
                                    [ngClass]="{'invalid':ChildForm.controls.b_day.invalid && ChildForm.controls.b_day.touched,
                                        'valid':!ChildForm.controls.b_day.invalid && ChildForm.controls.b_day.touched}"
                                    >
                                            <option *ngFor="let i of daysArray;index as idx;" 
                                            [value]="idx+1">{{idx+1}}</option>
                                    </select>
                                    <select formControlName="b_year" style="padding-left:15px;margin-left:5px;width:100px;height:39px;border:black solid 1px;border-radius:10px;background:white;"  
                                    [ngClass]="{'invalid':ChildForm.controls.b_year.invalid && ChildForm.controls.b_year.touched,
                                        'valid':!ChildForm.controls.b_year.invalid && ChildForm.controls.b_year.touched}"
                                    >
                                            <option *ngFor="let i of yearArray;index as idx;" 
                                            [value]="(today.getUTCFullYear()-idx).toString()">{{(today.getUTCFullYear()-idx).toString()}}</option>
                                    </select>
                            </div>
                        </div>
                    </div>
                <div class="flex -mx-3">
                    <div class="w-1/2 px-3 mb-5">
                      <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>First Name
                        
                    </label>
                      <div class="flex">
                          <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-account-outline text-gray-400 text-lg"></i></div>
                          <input formControlName="firstName" type="text" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none "
                          [ngClass]="{'invalid':ChildForm.controls.firstName.invalid && ChildForm.controls.firstName.touched,
                                        'valid':!ChildForm.controls.firstName.invalid && ChildForm.controls.firstName.touched}"
                          >
                      </div>
                  </div>    
                    <div class="w-1/2 px-3 mb-5">
                        <label for="" class="text-md font-semibold px-1"><strong style="color:red;">*</strong>Last Name</label>
                        <div class="flex">
                            <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-account-outline text-gray-400 text-lg"></i></div>
                            <input formControlName="lastName" type="text" class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none "
                            
                            [ngClass]="{'invalid':ChildForm.controls.lastName.invalid && ChildForm.controls.lastName.touched,
                                        'valid':!ChildForm.controls.lastName.invalid && ChildForm.controls.lastName.touched}"
                            >
                        </div>
                    </div>
                </div>
                </form>
                <div *ngIf="addingChild">
                <ng-container *ngIf="editingChild;else notEditingChild">
                            <button (click)="cancelAdd()" class="button button-next mr-1 w-20 text-white px-2 py-1 font-semibold">Cancel</button>
                            <button (click)="deleteAdd()" class="button button-next mr-1 w-20 text-white px-2 py-1 font-semibold">Delete</button>
                    </ng-container>
                    <ng-template #notEditingChild>
                            <button (click)="cancelAdd()" class="button button-next mr-1 w-20 text-white px-2 py-1 font-semibold hover-red" style="background:red;">Cancel</button>
                    </ng-template>
              <button (click)="addChild()" class="button button-next mr-1 w-20 text-white px-2 py-1 font-semibold hover-green" style="background:green;">Save</button>
              </div>
            </div>
            </ng-container>
            
<!--------FORM FINISH---------->


<ng-container *ngIf="page==3">
<h1><strong class="text-yellow-700">Step3: </strong>Terms & Conditions</h1>
<br>
<div  style="display:flex;flex-direction: column;position:relative;">

<div (scroll)="onWaiverScroll($event)" class="terms-box">

<p class="sections-box">
<strong>Welcome to Resistance Climbing</strong>
We’re stoked you’ve come to enjoy the fun, freedom and fitness of indoor rock climbing!
Our well-trained staff are passionate about climbing and are excited to help make your experience a
great one.
We’ve provided a high-quality facility with a strong focus on safety, but like all physical activities,
there are risks associated with bouldering and the use of this facility. Please read this safety waiver
carefully before using the climbing walls or equipment.
</p>

<h1>Activity Risks</h1>
The risks include but are not limited to:
<li>Falling to the ground or onto others</li>
<li>Being fallen on by other users</li>
<li>Sports injury and over-exertion</li>
<li>Injury through improper use of equipment.</li>
<li>Equipment failure</li>
<li>Other users not following the conditions of use</li>
<li>Abrasions from holds, walls, or the floor</li>
<li>Bruising, joint injuries, broken bones, head knocks from falls</li>
<p class="sections-box">
The risks of participating in bouldering and related activities may result in serious neck and
spinal injuries which may result in paralysis, serious injury or impairment to other aspects of
the body or even death.
</p>

<h1>Age Restrictions</h1>
<p class="sections-box">
To ensure we provide a safe space for everyone, we have to set some rules for younger climbers.
</p>
<li>The minimum age to climb at our gym is 5 years-old. Under 5’s who visit the gym must be
supervised at all times (within arm’s reach).</li>
<li>Under-13’s require adult supervision (1 adult: 3 climbers).</li>
<li>If you’re under 16, a parent (or guardian) will need to sign your waiver (this must be signed at
reception).</li>

<br>
<h1>Conditions of Use:</h1>
<br>
<h1>General</h1>
<li>All customers and visitors must check in at reception on arrival.</li>
<li>Be respectful of other people and their belongings and take care of our awesome facility.</li>
<li>Access to the back of any climbing wall is not permitted, except to use the fire escape during
a fire or equivalent emergency.</li>
<li>Participation in or supervision of any climbing or related activities whilst under the influence
of alcohol, drugs, or other substances is strictly prohibited.</li>
<li>If you are injured or witness an injury or unsafe or inappropriate behaviour please inform
staff immediately.</li>
<li>The premises is under video surveillance at all times. If you are seen exhibiting inappropriate
or unsafe behaviour or breaking any of the rules of Resistance Climbing you will be asked to
leave the building, may forfeit your membership and/or be banned from the facility.</li>


<h1>Bouldering:</h1>
<p class="sections-box">All first time or inexperienced climbers will be required to complete a safety induction with a
staff member prior to climbing.</p>
<li>All experienced climbers will be asked a short series of questions to demonstrate
competence. </li>

<li>Under-13s must be supervised by an adult who is experienced, or a member, or has
completed an induction. This means child and adult being on the matted area together
within clear sight of one another. An adult may supervise up to three children.</li>
<li>Mats do not guarantee safety, the safest descent method is down climbing.</li>
<li>Any fall may cause injury to yourself or others, please exercise caution at all times.</li>
<li>Keep the fall zone clear. Be aware of other climbers, and do not go underneath or over
another climber.</li>
<li>You are <strong>NOT</strong> permitted on top or over the back of the walls, or to access the mezzanine floor
by climbing over the top of the wall (no top-outs).</li>
<li>Inform a staff member if any holds spin or break.</li>
<li>Clean enclosed shoes are to be worn while climbing.</li>
<li>Food and drink is not permitted on the climbing mats.</li>
<li>Please keep personal belongings off the mats. Cubbies and lockers are provided.</li>

<br>
<h1>Privacy Policy</h1>
<p class="sections-box">
Resistance Climbing Gym is committed to personal privacy and compliance with current privacy legislation. Any personal information
collected and held will only be used or disclosed as follows:
</p>
<li>To prevent and resolve unauthorised access to, or attacks on our systems; or where
otherwise legally permitted.</li>
<li>CCTV surveillance is in use at this facility for safety and security.</li>
<li>Photos and video of users may be collected for security and marketing purposes. We will
endeavour to collect consent whenever possible if using images for marketing purposes and
will remove any published images online by reasonable request.</li>
<p class="sections-box">
By providing us with your email address you consent to receive emails from us advising of updates, products and services
available. You may unsubscribe from our email database at any time.
</p>

</div>
</div>
</ng-container>
<ng-container *ngIf="page==4">

<h1><strong class="text-yellow-700">Step4: </strong>Waiver Agreement</h1>

<br>
<div class="relative">
<div class="agreement-box">    
<div class="sections-box">
        A parent (or guardian) must sign below for anyone under 16 years-old and agree that they and the
        minor are subject to all the terms of this document, as set forth below and on the previous page.
        </div>
<h1>By signing below, I, <strong style="color:#CB5727">{{getCurrentName()}}</strong>, agree to the Terms and Conditions stated in this document.    
</h1>
<br>
<li>To use the facilities at your own risk, and take responsibility for any personal injury, property
loss or damage caused to you or any under-16 you are signing on behalf of.</li>
<li>To indemnify Resistance Climbing Gym and its directors, staff and contractors from liability
for any personal injury, property loss or damage caused to you, your next of kin or any
under-16 you are signing on behalf of.</li>
<li>To accept and follow the Resistance Climbing Gym Conditions of Use.</li>
<li>To accept the Resistance Climbing Gym Privacy Policy.</li>
<li>To disclose any pre-existing medical or other conditions that may affect the risk that either
yourself or any other person could suffer injury, loss or damage and will seek medical advice
before participating. This information will only be viewable by Resistance staff.</li>
<li>To authorise staff to instigate any necessary medical assistance and treatment required in an
emergency.</li>
<li>That these terms may be updated from time to time without notification, please refer to our
website for the most recent terms and conditions.</li>

</div>
</div>
<br>


            </ng-container>
<ng-container *ngIf="page==6">

</ng-container>
            <div class="sig-box" [ngStyle]="{'display': page==4 ? 'block' : 'none'}">
                    <strong style="margin-top:-25px;position:absolute;">Sign Here</strong> 
                <signature-pad  [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>
                <button (click)="clearPad()" class="button button-next block w-full text-white px-2 py-1 font-semibold">Reset Signature</button>
              </div>
                    <div class="flex -mx-3 mt-5">
                            <div class="w-1/2 px-3 mb-5">
                                <button (click)="startOver(true)" class="button button-next block w-full max-w-xs mx-auto text-white rounded-lg px-3 py-3 font-semibold">Start Over</button>
                        </div>
                        <ng-container *ngIf="page>0;else pageOne">                        
                        <div class="w-1/2 px-3 mb-5">
                                <button (click)="prevPage()" class="button button-next block w-full max-w-xs mx-auto text-white rounded-lg px-3 py-3 font-semibold">Prev</button>
                        </div>
                        <ng-container *ngIf="page==1">
                            
                            <div class="w-1/2 px-3 mb-5">
                                <button  
                                [ngClass]="{'disabled-button': !addressInfoForm.valid }"
                                (click)="nextPage()" class="button button-next block w-full max-w-xs mx-auto text-white rounded-lg px-3 py-3 font-semibold">Next</button>
                            </div>
                            </ng-container>
                        <ng-container *ngIf="page==2">
                                <div class="w-1/2 px-3 mb-5">
                                    <button (click)="nextPage()" class="button button-next block w-full max-w-xs mx-auto text-white rounded-lg px-3 py-3 font-semibold">Next</button>
                                </div>
                            </ng-container>
                        <ng-container *ngIf="page==3">
                                <div class="w-1/2 px-3 mb-5">
                                    <button 
                                    [ngClass]="{'disabled-button': !viewedFull}"
                                    (click)="nextPage()" class="button button-next block w-full max-w-xs mx-auto text-white rounded-lg px-3 py-3 font-semibold">Next</button>
                                </div>
                                </ng-container>
                        <ng-container *ngIf="page==4">
                                <div class="w-1/2 px-3 mb-5">
                                    <button (click)="submit()" class="button button-next block w-full max-w-xs mx-auto text-white rounded-lg px-3 py-3 font-semibold">Submit</button>
                                </div>
                                </ng-container>
                    </ng-container>
                    <ng-template #pageOne>
                            <div class="w-full px-3 mb-5">
                                <button 
                                [ngClass]="{'disabled-button': !basicInfoForm.valid}"
                                (click)="nextPage()" class="button button-next block w-full max-w-xs mx-auto text-white rounded-lg px-3 py-3 font-semibold">Next</button>
                            </div>                        
                    </ng-template>

                    </div>


                    <!--MAIN CONTENT BOX END-->
                </div>


<ng-container *ngIf="loading"> 
    <div class="lds-ring" >                          
        <img src="assets/logo2.png" >                                          
        <!--
        <p style="position:absolute;z-index:4;font-size:10px;
        left:25px;top:38px;width:100px;
            font-family: 'grifter'
        ">Fetching and storing waivers... <br>This might take a while...</p>
        -->
    <div></div>
    </div>
    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

